import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type KeyChildren} from './api';

const domain = 'EMPLOYEE_KEY_CHILDREN';

export const {action: showAddKeyChildModal} = createAction(`${domain}/SHOW_ADD_KEY_CHILD_MODAL`, () => ({}));

export const {action: hideAddKeyChildModal} = createAction(`${domain}/HIDE_ADD_KEY_CHILD_MODAL`, () => ({}));

export const {
    action: updateKeyChildren,
    success: updateKeyChildrenSuccess,
    failed: updateKeyChildrenFailed,
    aborted: updateKeyChildrenAborted,
} = createAction(
    `${domain}/UPDATE_KEY_CHILDREN`,
    (employeeId: string, keyChildren: KeyChildren, deletingChild?: {name: string; childId: string}) => ({
        employeeId,
        keyChildren,
        deletingChild,
    }),
    () => ({}),
);
